import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { TContentType } from "../types/types";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Wait before a task
export function pleaseWait(seconds: number) {
  return new Promise((resolve) => {
    setTimeout(resolve, seconds * 1000);
  });
}

// To extract first emoji character from a string
export function getFirstGrapheme(str: string) {
  const segmenter = new Intl.Segmenter("en", { granularity: "grapheme" });

  const iterator = segmenter.segment(str)[Symbol.iterator]();
  const firstSegment = iterator.next();
  return firstSegment.value?.segment;
}

// Get random item from an array
export function getRandomItem(arr: string[]) {
  const randomIndex = Math.floor(Math.random() * arr.length);
  return arr[randomIndex];
}

export function getRandomNumber(min: number, max: number) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

export function getTimeBasedGreeting() {
  const hour = new Date().getHours();

  if (hour >= 5 && hour < 12) return "Good morning";
  if (hour >= 12 && hour < 18) return "Good afternoon";
  if (hour >= 18 && hour < 22) return "Good evening";
  return "Good night";
}

// helper function to get the database field name for a content type
export function getContentField(contentType: TContentType) {
  switch (contentType) {
    case "chapter":
      return "chapterId";
    case "blog":
      return "blogId";
    case "course":
      return "courseId";
    default:
      return "chapterId";
  }
}

export function getValueChangeTrend(previousValue: number, currentValue: number) {
  let changeTrend;

  if (previousValue === 0) {
    if (currentValue === 0) {
      changeTrend = 0; // no revenue in both months, no change
    } else {
      changeTrend = 100; // from 0 to a positive number, so it's 100% growth
    }
  } else {
    changeTrend = ((currentValue - previousValue) / previousValue) * 100;
  }

  return Number(changeTrend.toFixed(2));
}

export function paginate<T>(array: T[], page: number, itemsPerPage: number): T[] {
  const start = (page - 1) * itemsPerPage;
  const end = start + itemsPerPage;

  return array.slice(start, end);
}

export function extractUsernameFromURL(url: string) {
  const urlData = new URL(url);
  const pathSegments = urlData.pathname.split("/").filter(Boolean); // ["username", "anything-siisdhish"]
  const username = pathSegments[0]; // "username"

  return username;
}

// Recycled

// 08 May 2025

// return `https://iframe.mediadelivery.net/play/${process.env.BUNNY_STREAM_LIBRARY_ID}/${videoPlaybackId}`;
// return `mux-playback-id:${videoPlaybackId}`
